import debounce from 'lodash/debounce';

const DEBOUNCE_TIME = 10000;

export default function defaultDebounce(fn: (...args: any) => any): (...args: any) => any {
  return debounce(fn, DEBOUNCE_TIME, { leading: true, trailing: false });
}
